import React from "react";

export const HeroHeader = ({ heading, subHeading }) => {
    return (
        <section className="py-8 mt-16 lg:mt-28">
            <div className="flex flex-col items-center gap-8 lg:px-32">
                <div className="hp-container flex flex-col items-center w-full">
                    <div className="text-center flex flex-col gap-4 mb-5 w-full md:max-w-[80%] mx-auto">
                        <h1 className="text-[48px] md:text-[60px] lg:text-[80px] font-normal text-black leading-[58px] md:leading-[70px] lg:leading-[80px] lg:max-w-full mx-auto">
                            {heading}
                        </h1>
                        <p className="font-normal text-[14px] md:text-[16px] xl:text-[18px]text-gray">
                            {subHeading}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
